<nav class="navbar sticky-top bg-body-tertiary navbar-expand-sm">
    <div class="container-fluid">
        <a class="navbar-brand" data-ta-name="musicCollectionNavbarLink" href="#">
            <i class="fa fa-music"></i>
            My Music Collection
        </a>
        <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed" 
                data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" 
                [attr.aria-expanded]="!isCollapsed" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent" [collapse]="isCollapsed">
            <ul class="navbar-nav me-auto mb-2 mb-sm-0">
                <li class="nav-item">
                    <a class="nav-link" ariaCurrentWhenActive="page" routerLinkActive="active" routerLink="/artistCollection" data-ta-name="artistsNavbarLink">Artists</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" ariaCurrentWhenActive="page" routerLinkActive="active" routerLink="/albumCollection" data-ta-name="albumsNavbarLink">Albums</a>
                </li>
            </ul>
        </div>        
    </div>
</nav>